export { DecompositionSectionComponentButton } from "#decomposition-section-component-button";
